<template>
	<div class="page-single-property" ref="single_property">
		<div class="page-single-property__container">
			<div class="page-single-property-header-container">
				<div class="page-single-property__header">
					<div class="properties-header" ref="propertiesHeader">
						<div class="properties-header__info">
							<div class="properties-header__info-details">
								<div class="properties-header__info-details-top">
									<a class="properties-header__btn" @click="goBack()">
										<SvgIcon class="properties-header__icon" iconName="ico-arrow-left"/>
									</a>
									<h1 class="section-title properties-header__name" v-if="property.title">
										{{ property.title }}
										<span class="properties-header__name-contract" v-if="property.listing_status_label === 'In Contract'">{{property.listing_status_label}}</span>
									</h1>
								</div>
								<div class="properties-header__info-details-bottom">
									<div class="properties-header__info-wrap">
										<span class="properties-header__card properties-header__card--green" v-if="isNewProperty() && property.created_at">New</span>
										<span class="properties-header__card properties-header__card--blue" v-if="property.offering_type">{{ checkOfferingType() }}</span>
										<span class="properties-header__card properties-header__card--orange" v-if="property.listing_type !== 'open' && property.listing_type_label">{{ property.listing_type_label}}</span>
									</div>
									<div class="properties-header__price" v-if="property.regular_price">
										${{formatNumbers(property.regular_price)}}
									</div>
									<div class="properties-header__price" v-else>
										${{formatNumbers(property.lease_price)}} per month
									</div>
									<div class="properties-header__info-content">
										<span class="properties-header__info-content-name" v-if="property.building_size">
											<SvgIcon class="properties-header__info-content-name-icon" iconName="ico-ruler"/>
											<span class="properties-header__info-content-text">
												{{ formatNumbers(property.building_size) }} SF
											</span>
										</span>
										<span class="properties-header__info-content-name" v-if="property.owner_name && !property.hide_owner">
											<SvgIcon class="properties-header__info-content-name-icon" iconName="ico-user-clasic"/>
											<span class="properties-header__info-content-text">{{ property.owner_name }}</span>
										</span>
									</div>
								</div>
							</div>
						</div>
						<div class="properties-header__container">
							<div class="properties-header__description">
								<p class="properties-header__info-content-txt" v-if="property.description">{{ property.description }}</p>
							</div>
							<div class="properties-header__buttons">
								<div class="properties-header__half-btn properties-header__download-btn">
									<div id="document-picker">
										<div class="properties-header__wrapper">
											<span class="properties-header__wrapper-btn" @click="toggleDropdown()">
												<SvgIcon class="properties-header__file-icon" iconName="ico-pdf-file"/>
												Download PDF
											</span>
											<ul class="properties-header__dropdown" v-if="active" v-on-click-outside="close">
												<li class="properties-header__dropdown-item" v-for="document in documents" :key="document.id">
													<a class="properties-header__dropdown-link" v-if="document.show" :id="document.linkId" :href="document.docLink" :target="document.target">
														<span :style="{background: document.hex}"></span>
														{{document.name}}
													</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div class="properties-header__half-btn">
									<router-link class="btn btn--mid properties-header__history-btn" id="history-link" :to="{ name: goInDashboard() ? 'PropertyHistoryAdmin' : 'PropertyHistoryAgent', params: { id: $route.params.id } }">
										<span>Lead History</span>
									</router-link>
								</div>
								<div class="properties-header__half-btn" v-if="checkPermissions()">
									<router-link class="btn btn--grey properties-header__edit-btn" id="edit-details-link" :to="{ name: 'EditProperty', params: { id: $route.params.id } }">
										<SvgIcon class="properties-header__edit-icon" iconName="ico-pen"/>
										<span>Edit Details</span>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="single-property__content">
				<div class="single-property__content-wrap">
					<div class="single-property__content-small">
						<div class="single-property__content-images">
							<div class="single-property__gallery">
								<!-- Gallery Input -->
								<BlockGallery :data="DataGallery"/>
							</div>
							<div class="single-property__map">
								<!-- Map -->
								<BlockMapInput
									:data="DataMapProperty"
									ref="map"
								/>
							</div>
						</div>
					</div>
					<div class="single-property__content-big">
						<!-- Single Property Form -->
						<div class="single-property-deatils">
							<div class="container-fluid single-property-deatils__container">
								<div class="row">
									<div class="col-lg-6 col-md-6">
										<div class="property-details">
											<div class="property-details__wrapper">
												<div class="property-details__note">
													<span class="property-details__label">Admin’s Note</span>
													<span class="property-details__placeholder-note" v-html="property.note ? property.note : ''">{{property.note ? property.note : '-'}}</span>
												</div>
												<PartDetailsList :data="DataDetailsAddress" v-if="DataDetailsAddress.items.length > 0"/>
											</div>
											<transition name="fade" appear>
												<div class="property-details__new-note">
													<span class="property-details__label">NOTE</span>
													<p class="property-details__note-added property-details__note-placeholder" v-if="notes.length === 0">

													</p>
													<ul class="property-details__note-added-list" v-else>
														<li class="property-details__note-added" ref="listItem" v-for="(note, index) in notes" :key="index">
															<div>
																<span class="property-details__note-added-pre">*</span>
																<span class="view property-details__note-added-input" v-if="checkPermissions()">
																	<b>{{note.agent_name}}</b> - {{note.description}}
																</span>
																<span class="view property-details__note-added-input" v-else>
																	{{note.description}}
																</span>
															</div>
															<div>
																<a class="property-details__note-added-icon property-details__note-added-icon--delete" @click="deleteRow(note.id)" v-if="note.agent_id === user.id">
																	<SvgIcon class="property-details__btn-icon" iconName="ico-delete"/>
																</a>
																<a class="property-details__note-added-icon property-details__note-added-icon--edit edit-btn" @click="editNote(note.id)" v-if="note.agent_id === user.id">
																	<SvgIcon class="property-details__btn-icon" :iconName="iconDelete"/>
																</a>
															</div>
															<PartPopupDelete
																v-if="showPopupDelete"
																:data="PopupDelete"
																@confirmPopupDelete="confirmPopupDelete"
																@closePopupDelete="closePopupDelete"
															>
																<template v-slot:popupTitle>Are you sure you want to delete this Note?</template>
																<template v-slot:popupCancel>No</template>
																<template v-slot:popupConfirm>Yes</template>
															</PartPopupDelete>
														</li>
													</ul>
												</div>
											</transition>
											<div class="page-single-property__note-textarea">
												<transition name="fadeHeight" appear>
													<div v-if="noteShow" class="page-single-property__note-popup">
														<div class="page-single-property__note-popup-wrap" v-on-click-outside.static="closeNote">
															<h1 class="section-title section-title--sm section-title--page-edit-note"> Add Note</h1>
															<PartInputTextarea
																@countdown="countdown"
																v-model="enteredNoteValue"
																:data="DateTextareaNote"
																ref="notePopupText"
															/>
															<p class='page-single-property__note-textarea-counter' v-bind:class="{'text-danger': hasError }">{{ remainingCount }}/{{ maxCount }}</p>
															<div class="page-single-property__note-btns">
																<a class="btn btn--md btn--white single-property-note-btn single-property-note-btn--cancel" @click="closeNote()">
																	<span>Cancel</span>
																</a>
																<a class="btn btn--md single-property-note-btn" @click="addNote()" :class="{'btn--disabled': !enteredNoteValue.length}" :disabled="!enteredNoteValue.length">
																	<SvgIcon class="property-details__btn-icon" iconName="ico-save"/>
																	<span>Save Note</span>
																</a>
															</div>
														</div>
													</div>
												</transition>
												<transition name="fade" appear>
													<div class="notification-wrap-side--single-property" v-if="notificationsData.msg">
														<PartNotifications :data="notificationsData"/>
													</div>
												</transition>
												<a class="btn btn--md single-property-note-btn" @click="newNote()" ref="buttonAdd" v-if="user.role !== 'admin' && user.role !== 'super_admin'">
													<SvgIcon class="property-details__btn-icon property-details__btn-icon--plus" iconName="ico-plus"/>
													<span>Add Note</span>
												</a>
											</div>
										</div>
										<PartDetailsList :data="DataDetailsFeature" v-if="DataDetailsFeature.items.length > 0"/>
										<PartDetailsList :data="DataDetailsOwner" v-if="DataDetailsOwner.items.length > 0 && !property.hide_owner"/>
									</div>
									<div class="col-lg-6 col-md-6">
										<PartDetailsList :data="DataDetailsProperty" v-if="DataDetailsProperty.items.length > 0"/>
										<PartDetailsList :data="DataDetailsBuilding" v-if="DataDetailsBuilding.items.length > 0"/>
										<PartDetailsList :data="DataDetailsLot" v-if="DataDetailsLot.items.length > 0"/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<transition name="fade" appear>
			<PartLoaderBig v-if="pageLoader"/>
		</transition>
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import PartLoaderBig from '@/components/parts/PartLoaderBig';
import BlockMapInput from '@/components/blocks/BlockMapInput';
import BlockGallery from '@/components/blocks/BlockGallery';
import { mixin as onClickOutside } from 'vue-on-click-outside';
import PartDetailsList from '@/components/parts/PartDetailsList';
import PartInputTextarea from '@/components/parts/PartInputTextarea';
import PartPopupDelete from '@/components/parts/PartPopupDelete';
import PartNotifications from '@/components/parts/PartNotifications';
import { check } from '@/services/RouteGuards/SuperAdmin';
import { formatDate, formatNumber, formatMixStrNum } from '@/config/util';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	components: {
		PartNotifications,
		BlockMapInput,
		BlockGallery,
		SvgIcon,
		PartDetailsList,
		PartInputTextarea,
		PartPopupDelete,
		PartLoaderBig
	},
	data () {
		return {
			pageLoader: true,
			propertyId: this.$route.params.id,
			editAgentNote: false,
			noteId: null,
			property: {},
			showPopupDelete: false,
			PopupDelete: {
				itemID: ''
			},
			notificationsData: {
				type: '',
				msg: ''
			},
			DataDetailsOwner: {
				title: 'Owner',
				items: []
			},
			DataDetailsAddress: {
				title: 'Address',
				items: []
			},
			DataDetailsProperty: {
				title: 'Property',
				items: []
			},
			DataDetailsBuilding: {
				title: 'Building',
				items: []
			},
			DataDetailsLot: {
				title: 'Lot',
				items: []
			},
			DataDetailsFeature: {
				title: 'Features',
				items: []
			},
			maxCount: 125,
			remainingCount: 125,
			hasError: false,
			noteShow: false,
			iconDelete: 'ico-edit',
			DateTextareaNote: {
				inputId: 'single-property-textarea-input',
				classTextarea: 'single-property__textarea',
				inputVal: 'enteredNoteValue',
				maxlength: 125
			},
			enteredNoteValue: '',
			DataMapProperty: {},
			DataGallery: {
				gallery_absolute: []
			},

			userComeFrom: '',

			// PDF
			documents: [
				{
					name: 'Agent Version',
					docLink: `${process.env.VUE_APP_BACKEND_URL}/pdf/agent/download/${this.$route.params.id}`,
					target: '_blank',
					linkId: 'agent',
					show: true
				},
				{
					name: 'Client Version',
					docLink: `${process.env.VUE_APP_BACKEND_URL}/pdf/client/download/${this.$route.params.id}`,
					target: '_blank',
					linkId: 'client',
					show: true
				}
			],
			active: false,
			visible: false,
			classScroll: 'prevent-scroll'
		};
	},

	created() {
		this.$store.dispatch('fetchNotes', this.propertyId);
	},

	computed: {
		notes() {
			return this.$store.getters.getNotes;
		},
		user() {
			return this.$store.getters.getUser;
		},
		propertyInfo() {
			return this.$store.getters.getPropertyInfo;
		}
	},
	async mounted() {
		const obj = {
			order_by: 'last_name',
			order: 'asc',
			id: this.$route.params.id,
			page: 1
		};
		await Promise.all([
			this.$store.dispatch('fetchStages'),
			this.$store.dispatch('matchingProperties', obj),
			this.$store.dispatch('customersForMatching', obj)
		]);
		this.$refs.single_property.parentNode.classList.add('site-main--full-page');
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
		this.$store.dispatch('fetchProperty', this.propertyId).then(response => {
			this.property = response.data.property;
			this.DataGallery.gallery_absolute = this.property.gallery_absolute;
			if (response.data.property.map.street) {
				this.$refs.map.renderMap(response.data.property.map);
			}
			// else {
			// 	this.$refs.map.renderMapImported(response.data.property);
			// }

			this.documents.push({
				name: 'Eretz Flyer',
				docLink: `${process.env.VUE_APP_BACKEND_URL}/custom/download?id=${JSON.parse(localStorage.getItem('user')).id}&url=${this.propertyInfo.unpersonalized_pdf_url}`,
				target: '_blank',
				linkId: 'flyer',
				show: true
			});

			// Fill details parts with data
			// Owner
			this.DataDetailsOwner.items = [
				{ name: 'Owner Name', information: this.property.owner_name },
				{ name: 'Owner Email', information: this.property.owner_email },
				{ name: 'Owner Phone', information: this.property.owner_phone },
				{ name: 'Owner Phone 2', information: this.property.owner_phone_2 }
			];

			// Address
			this.DataDetailsAddress.items = [
				{ name: 'Street', information: this.property.street_name },
				{ name: 'Street Number', information: this.property.street_number },
				{ name: 'Postal Code', information: this.property.zip },
				{ name: 'Neighborhood', information: this.property.neighborhood },
				{ name: 'Cross Street', information: this.property.cross_street },
				{ name: 'Area', information: this.regroupArea(this.property.area_label[0]) },
				{ name: this.property.category === 2 ? 'State' : '', information: this.property.state }
			];

			// General
			this.DataDetailsProperty.items = [
				{ name: 'Price', hide: !this.property.regular_price, information: this.property.regular_price ? '$' + this.formatNumbers(this.property.regular_price) : '' },
				{ name: 'Price per Square Foot', hide: !this.property.price_psf, information: this.property.price_psf ? '$' + this.formatNumbers(this.property.price_psf) : '' },
				{ name: 'Price per Buildable Square Foot', hide: !this.property.price_buildable_sf, information: this.property.price_buildable_sf ? '$' + this.formatNumbers(this.property.price_buildable_sf) : '' },
				{ name: 'Yearly Price per Square Foot', hide: !this.property.show_yearly_price, information: this.property.yearly_price ? '$' + this.formatNumbers(this.property.yearly_price) : '' },
				{ name: 'Lease Price', hide: !this.property.lease_price, information: this.property.lease_price ? '$' + this.formatNumbers(this.property.lease_price) + ' per month' : '' },
				{ name: 'Priority', information: this.property.priority ? 'Yes' : 'No' },
				{ name: this.property.category === 1 ? 'Publicize Status' : '', information: this.property.publicize ? 'Yes' : 'No' },
				{ name: 'Property Type', information: this.property.property_type_label },
				// { name: 'Property Sub Type', information: this.property.property_sub_type_label },
				{ name: 'Listing Status', information: this.property.listing_status_label },
				{ name: 'Exclusive Expiration', information: this.property.exclusive_expiration ? this.changeDateFormat(this.property.exclusive_expiration_date) : 'No' },
				{ name: 'Listing Type', information: this.property.listing_type_label },
				{ name: 'Offering Type', information: this.property.offering_type_label },
				{ name: 'Date Listed', information: this.changeDateFormat(this.property.date_listed) },
				{ name: 'Date Verified', information: this.changeDateFormat(this.property.date_verified) },
				{ name: 'Agent', information: this.property.agent_name },
				{ name: 'Source', information: this.property.lead_source },
				{ name: 'Property Shark Link', information: this.property.property_shark_link },
				{ name: 'Description', information: this.property.description }
			];

			// Building
			this.DataDetailsBuilding.items = [
				{ name: 'Building Group Label', information: this.property.building_group_label },
				{ name: 'Building Irregular', information: this.property.building_irregular ? 'Yes' : 'No' },
				{ name: 'Size', information: this.property.building_size ? this.formatNumbers(this.property.building_size) + ' SF' : '' },
				{ name: 'Width', information: this.property.building_width ? this.formatNumbers(this.property.building_width) + ' feet' : '' },
				{ name: 'Length', information: this.property.building_length ? this.formatNumbers(this.property.building_length) + ' feet' : '' },
				{ name: 'Building Note', information: this.property.building_note }
			];

			// Lot
			this.DataDetailsLot.items = [
				{ name: 'Lot Irregular', information: this.property.lot_irregular ? 'Yes' : 'No' },
				{ name: 'Size', information: this.property.lot_size ? this.formatNumbers(this.property.lot_size) + ' SF' : '' },
				{ name: 'Width', information: this.property.lot_width ? this.formatNumbers(this.property.lot_width) + ' feet' : '' },
				{ name: 'Length', information: this.property.lot_length ? this.formatNumbers(this.property.lot_length) + ' feet' : '' },
				{ name: 'Lot Note', information: this.property.lot_note }
			];

			// Features
			this.DataDetailsFeature.items = [
				{ name: 'FAR', information: this.property.far ? this.formatMix(this.property.far) : '' },
				{ name: 'Total Buildable', information: this.property.total_buildable ? this.formatMix(this.property.total_buildable) + ' SF' : '' },
				{ name: 'Income', information: this.property.income ? this.formatMix(this.property.income) : '' },
				{ name: 'Expenses', information: this.property.expenses ? this.formatMix(this.property.expenses) : '' },
				{ name: 'Zoning', information: this.property.zoning },
				{ name: 'Number of Floors', information: this.property.number_of_floors },
				{ name: this.property.category === 2 ? 'Cap Rate' : '', information: this.property.cap_rate },
				{ name: 'NOI', information: this.property.noi ? this.formatMix(this.property.noi) : '' },
				{ name: 'Layout', information: this.property.layout },
				{ name: this.property.category === 1 ? 'Garage' : '', information: this.property.garage },
				{ name: this.property.category === 1 ? 'Parking' : '', information: this.property.parking },
				{ name: this.property.category === 1 ? 'Material' : '', information: this.property.material }
			];

			this.pageLoader = false;
		}).catch(error => {
			if (error?.response?.data?.message && error?.response?.data?.message?.includes('No query results')) {
				this.$router.push({ name: '404' });
			}
			console.log(error);
		});
	},

	destroyed() {
		document.querySelector('.site-main').classList.remove('site-main--full-page');
	},
	mixins: [onClickOutside],

	// Check from where user come on single property
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.startedPosition(from.name);
		});
	},
	methods: {
		regroupArea(area) {
			if (area === 'Near Brooklyn') {
				return 'New Jersey';
			} else if (area === 'Near Boro Park') {
				return 'Brooklyn';
			} else {
				return area;
			}
		},
		isNewProperty() {
			const today = new Date().toISOString();

			const diffInMs = new Date(today) - new Date(this.property.created_at);
			const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

			// Check if property is created before 30 or more days
			return Math.round(diffInDays) < 30;
		},
		checkOfferingType() {
			let newItem;
			if (this.property.offering_type_label.length) {
				for (let i = 0; i < this.property.offering_type_label.length; i++) {
					newItem += `, ${this.property.offering_type_label[i]}`;
				}
			} else {
				newItem = this.property.offering_type;
			}
			newItem = newItem.substr(newItem.indexOf(',') + 1);
			return newItem;
		},
		formatNumbers(field) {
			return formatNumber(field);
		},
		formatMix(field) {
			return formatMixStrNum(field);
		},
		changeDateFormat(date) {
			return formatDate(date);
		},
		checkPermissions() {
			return check();
		},
		goInDashboard() {
			return this.$route.fullPath.includes('admin');
		},
		toggleDropdown: function() {
			this.active = !this.active;
		},
		open() {
			this.active = true;
		},
		close() {
			this.active = false;
		},
		startedPosition(name) {
			this.userComeFrom = name;
		},
		countdown() {
			this.remainingCount = this.maxCount - this.enteredNoteValue.length;
		},
		addNote() {
			let note = {};

			if (this.editAgentNote) {
				note = {
					id: this.noteId,
					property_id: this.propertyId,
					description: this.enteredNoteValue
				};
			} else {
				note = {
					property_id: this.propertyId,
					description: this.enteredNoteValue
				};
			}

			this.$store.dispatch('updateNote', note).then(response => {
				this.$store.dispatch('fetchNotes', this.propertyId);
				if (undefined !== response.data) {
					this.notification = response.data.message;
				}
				this.closeNote();
			});
		},
		editNote(id) {
			this.noteShow = true;
			this.editAgentNote = true;
			this.noteId = id;

			setTimeout(() => {
				this.$refs.notePopupText.$refs.inputArea.focus();
			}, 100);

			this.notes.forEach(el => {
				if (el.id === id) {
					this.enteredNoteValue = el.description;
				}
			});

			this.remainingCount = this.maxCount - this.enteredNoteValue.length;
		},
		deleteNote(id) {
			this.$store.dispatch('deleteNote', id).then(response => {
				this.$store.dispatch('fetchNotes', this.propertyId);
				if (undefined !== response.data) {
					this.notification = response.data.message;
				}
			});
		},
		newNote() {
			this.editAgentNote = false;
			this.noteShow = true;
			setTimeout(() => {
				this.$refs.notePopupText.$refs.inputArea.focus();
			}, 100);
		},
		closeNote() {
			this.noteShow = false;
			this.enteredNoteValue = '';
			this.remainingCount = 125;
		},
		deleteRow(id) {
			this.showPopupDelete = true;
			this.PopupDelete.itemID = id;
		},
		closePopupDelete() {
			this.showPopupDelete = false;
		},
		confirmPopupDelete(id) {
			this.showPopupDelete = false;
			this.deleteNote(id);
		},
		notification(msg, status) {
			this.notificationsData.msg = msg;
			this.notificationsData.type = status === 200 ? 'success' : 'danger';

			setTimeout(() => {
				this.notificationsData.msg = '';
				this.notificationsData.type = '';
			}, 2000);
		},
		goBack() {
			this.$router.go(-1);
		}
	}
};
</script>
<style lang="scss" scoped>
.page-single-property__container {
	@media only screen and (min-width: 1920px) {
		max-width: 1920px;
		margin: 0 auto;
	}
}
.page-single-property__note-textarea-counter {
	font-size: 14px;
	display: flex;
	justify-self: flex-end;
	color: $fiord;
	font-family: $font-main;
	align-self: flex-end;
}

.page-single-property__note-btns {
	display: flex;
	width: 100%;
	justify-content: flex-end;
}

.single-property-note-btn--cancel {
	margin-right: 15px;
}

.btn--disabled {
	opacity: .5;
	cursor: default !important;

	@include hover {
		background-color: $dodger-blue;
		color: $white;
	}
}

.page-single-property-header-container {
	background-color: $white;
	padding: 0 15px;
}

.page-single-property__header {
	margin: 0 34px 0 15px;

	@include mq(1800px) {
		margin: 0;
	}
}

.page-single-property {
	padding-bottom: 50px;
	height: 100vh;
	background-color: $athens-gray;
}

.single-property__content {
	max-width: 100%;
	width: 100%;
	padding-top: 22px;
	background-color: $athens-gray;
	border-top: 1px solid $grey-light;

	@include mq(1500px) {
		padding-top: 20px;
	}
}

.single-property__content-images {
	padding: 27px;
	background-color: $white;

	@include mq($xl) {
		padding: 20px;
		margin-bottom: 20px;
	}

	@include mq($lg) {
		display: flex;
		justify-content: space-between;
	}

	@include mq($md) {
		flex-direction: column;
		padding: 15px;
	}
}

.single-property__content-wrap {
	display: flex;
	padding: 0 15px 50px;

	@include mq(1800px) {
		padding: 0 0 50px;
	}

	@include mq($lg) {
		flex-direction: column;
		padding: 0 0 40px;
	}
}

.single-property__content-small,
.single-property__content-big {
	position: relative;
	width: 100%;
	min-height: 1px;
	padding-right: 15px;
	padding-left: 15px;
}

.single-property__content-small {
	flex: 0 0 37.5%;
	max-width: 37.5%;

	@include mq($lg) {
		flex: 0 0 100%;
		max-width: 100%;
	}
}

.single-property__content-big {
	flex: 0 0 62.5%;
	max-width: 62.5%;

	@include mq($lg) {
		flex: 0 0 100%;
		max-width: 100%;
	}
}

/*--------------------------------------------------------------
## Map
--------------------------------------------------------------*/
.single-property__map {
	@include mq($lg) {
		flex: 0 0 48%;
		max-width: 48%;
	}

	@include mq($md) {
		flex: 0 0 100%;
		max-width: 100%;
	}
}

.single-property__map {
	position: relative;
}

/*--------------------------------------------------------------
## Gallery
--------------------------------------------------------------*/
.single-property__gallery {
	min-height: 371px;
	max-height: 371px;
	position: relative;
	margin-bottom: 28px;

	@include mq($xl) {
		margin-bottom: 20px;
	}

	@include mq($lg) {
		min-height: auto;
		flex: 0 0 48%;
		max-width: 48%;
	}

	@include mq($md) {
		flex: 0 0 100%;
		max-width: 100%;
	}

	@include mq($sm) {
		min-height: 300px;
		max-height: 300px;
	}
}

/*--------------------------------------------------------------
## Details
--------------------------------------------------------------*/
.notification-wrap-side--single-property {
	margin: 10px auto;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: $dur $ease;
}
.property-details__wrapper,
.property-details__new-note,
.property-details__note,
.property-details {
	margin-bottom: 19px;

	@include mq($lg) {
		margin-bottom: 15px;
	}
}

.property-details__label {
	font-size: 14px;
	font-weight: bold;
	letter-spacing: 1px;
	font-family: $font-main;
	display: block;
	color: $fiord;
	background-color: $grey-light;
	padding: 10px 20px;

	@include mq($xl) {
		padding: 10px 15px;
	}
}

.property-details__placeholder-note {
	padding: 18px 20px;
	background-color: $white;
	border-right: none;
	border-left: none;
	display: block;
	min-height: 39px;
	font-size: 14px;
	color: $fiord;

	@include mq(1500px) {
		padding: 20px 15px;
	}

	@include mq(1440px) {
		font-size: 12px;
	}

	@include mq($xl) {
		padding: 15px;
	}
}

.property-details__btn-icon {
	font-size: 19px;
	height: 19px;
	margin-right: 10px;

	@include mq($lg) {
		font-size: 16px;
		height: 17px;
	}

	@include mq($md) {
		font-size: 14px;
		height: 14px;
	}
}

.property-details__btn-icon--plus  {
	font-size: 14px;
	display: flex;
	align-items: center;
}

.property-details__note-added-list {
	border-right: none;
	border-left: none;
	max-height: 200px;
	overflow: auto;
	overflow-wrap: break-word;
	margin-bottom: 0;
	background-color: $white;
	padding: 22px 20px;

	@include mq(1500px) {
		padding: 20px 15px;
	}

	@include mq($xl) {
		padding: 15px;
	}

	&::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}

	&::-webkit-scrollbar-track {
		background: #eceeef;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #42526e;
		border-radius: 20px;
		border: 1px solid #eceeef;
	}
		scrollbar-width: thin;
		scrollbar-color: #42526e #eceeef;
}

.property-details__note-placeholder {
	vertical-align: top;
	border-right: none;
	border-left: none;
	min-height: 39px;
	background-color: $white;
	padding: 22px 20px;

	@include mq(1500px) {
		padding: 20px 15px;
	}
}

.property-details__note-added {
	font-family: $font-main;
	color: $fiord;
	font-size: 16px;
	line-height: 20px;
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	position: relative;
	overflow-wrap: break-word;
	height: auto;
	margin-bottom: 0;
}

.property-details__note-added-pre {
	position: absolute;
	top: 0;
	left: 0;
}

.property-details__note-added-input {
	font-family: $font-main;
	color: $red;
	font-size: 14px;
	line-height: 20px;
	border: none;
	width: 100%;
	display: block;
	resize: none;
	padding-left: 16px;
	@include mq(1440px) {
		font-size: 12px;
	}

	&:disabled {
		background-color: transparent;
	}

	&.view {
		color: $fiord;
	}

	&.edit-note {
		cursor: text;
	}
}

.toggle-icon {
	.edit-btn {
		display: none;
	}

	.save-btn {
		display: block;
	}
}

.save-btn {
	display: none;
}

.property-details__note-added-icon {
	font-size: 15px;
	height: 15px;
	cursor: pointer;
	color: $red;
	transition: $dur $ease;
	margin-left: auto;
	background-color: transparent;
	border: none;

	@include mq($sm) {
		font-size: 10px;
	}

	@include hover {
		color: $dodger-blue;
	}
}

.single-property-note-btn {
	align-items: center;
	margin-bottom: 19px;

	.property-details__btn-icon {
		font-size: 15px;
		height: 15px;
	}
}

.single-property-note-btn--cencel {
	margin-left: 30px;
}

.property-details__note-added-icon--edit {
	color: $fiord;
	margin-left: 0;
	transition: $dur $ease;
}

.fade-enter-active, .fade-leave-active {
	transition: opacity .4s;
}

.fade-enter, .fade-leave-to {
	opacity: 0;
}

.fadeHeight-enter-active,
.fadeHeight-leave-active {
transition: all 0.2s;
height: 147px;
}
.fadeHeight-enter,
.fadeHeight-leave-to
{
opacity: 0;
height: 0;
}
.properties-header {
	display: flex;
	flex-direction: column;
	padding-top: 31px;

	@include mq($xl) {
		padding-top: 10px;
	}
}

.properties-header__container {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 2px 0 22px 34px;

	@include mq($lg) {
		margin: 0 0 20px 34px;
		padding: 0;
		flex-direction: column;
		justify-content: center;
		align-items: baseline;
	}

	@include mq(640px) {
		margin: 0 0 20px 0;
	}

	.properties-header__btn {
		max-width: 147px;
		padding: 10px;
		align-items: center;

		@include mq($md) {
			padding: 9px;
		}

		@include hover {
			.properties-header__icon {
				color: $dodger-blue;
			}
		}
	}

	.properties-header__edit-btn {
		min-width: 127px;
		max-width: 130px;
		margin-left: 29px;
		padding: 9px 5px;

		@include mq($lg) {
			margin-left: 0;
		}

		@include mq($md) {
			padding: 8px 5px;
			min-width: 120px;
			max-width: 120px;
		}
	}
}

.properties-header__breadcrumb {
	@include mq($lg) {
		margin-bottom: 20px;
	}
}

.properties-header__history-btn {
	margin-left: 13px;
	min-width: 113px;

	@include mq($lg) {
		margin-left: 0;
		min-width: 100px;
	}
}

.properties-header__half-btn--customer {
	@include mq($lg) {
		margin-left: auto;
	}
}

.properties-header__half-btn {
	&:not(:first-child) {
		@include mq(490px) {
			margin-left: 5px;
			margin-right: 5px;
		}
	}

	&:first-of-type {
		margin-left: 0;
	}

	@include mq($lg) {
		margin-left: 10px;
	}

	@include mq(490px) {
		width: auto;
		justify-content: space-around;
		align-items: baseline;
		display: flex;
	}

	@include mq(370px) {
		width: auto;
		justify-content: space-around;
		align-items: baseline;
		display: flex;

		&:first-child {
			margin-right: 10px;
		}
	}
}

.properties-header__customer {
	margin-left: 109px;

	@include mq($lg) {
		margin-left: 0;
	}
}

.properties-header__edit-icon {
	font-size: 19px;
	height: 20px;
	display: block;
	margin-right: 15px;

	@include mq($md) {
		font-size: 15px;
		margin-right: 10px;
	}
}

.properties-header__link {
	color: $fiord;
	transition: $dur $ease;

	@include hover {
		.properties-header__icon {
			color: $dodger-blue;
		}
	}
}

.properties-header__icon {
	display: flex;
	margin-right: 5px;
	font-size: 30px;
	color: $fiord;
	transition: $dur $ease;
	cursor: pointer;

	@include hover {
		color: $dodger-blue;
	}
}

.properties-header__wrapper {
	position: relative;
	min-width: 179px;
	width: 100%;
	border-radius: 8px;
	border: 1px solid $fiord;
	background-color: $white;
	color: $fiord;
	font-family: $font-main;
	font-weight: 500;
	font-size: 14px;
	line-height: 1;
	outline: none;
	cursor: pointer;
	transition: $dur $ease;

	@include hover {
		border: 1px solid $dodger-blue;
		color: $dodger-blue;

		.properties-header__wrapper-btn:after {
			border-color: $dodger-blue transparent;
		}

		.properties-header__dropdown {
			border: 1px solid $dodger-blue;
			border-top: 0;
		}
	}
}
.properties-header__wrapper > .properties-header__wrapper-btn {
	width: 100%;
	display: flex;
	align-items: center;
	border: none;
	padding: 10px 11px;

	@include mq($md) {
		padding: 9px;
	}
}

.properties-header__wrapper-btn:after {
	content: "";
	width: 0;
	height: 0;
	position: absolute;
	right: 16px;
	top: calc(50% + 4px);
	margin-top: -6px;
	border-width: 6px 6px 0 6px;
	border-style: solid;
	border-color: $fiord transparent;
	transition: $dur $ease;
}

.properties-header__dropdown {
	position: absolute;
	z-index: 10;
	top: 98%;
	left: -1px;
	right: 0;
	font-weight: normal;
	list-style-type: none;
	padding-left: 0;
	margin: 0;
	border: 1px solid $fiord;
	border-top: 0;
	background-color: $white;
	transition: $dur $ease;
	width: 101.2%;
	border-bottom-right-radius: 14px;
	border-bottom-left-radius: 14px;
}

.properties-header__dropdown-item {
	display: block;
	text-decoration: none;
	color: $fiord;
	cursor: pointer;
	transition: $dur $ease;

	&:not(:last-of-type) {
		border-bottom: 1px solid $grey-light;
	}

	@include hover {
		background-color: $athens-gray;
		.properties-header__dropdown-link {
			color: $dodger-blue;
		}
	}
}

.properties-header__file-icon {
	padding: 0;
	font-size: 18px;
	margin-right: 12px;
	/* transition: $dur $ease; */
}

.properties-header__dropdown-link {
	font-family: $font-main;
	font-size: 14px;
	padding: 10px;
	display: block;
	color: $fiord;
	transition: $dur $ease;
	text-decoration: none;
}

.properties-header__buttons {
	display: flex;

	@include mq($lg) {
		width: 100%;
		justify-content: center;
		flex-wrap: wrap;
	}
}
.properties-header__download-btn {
	@include mq($lg) {
		margin-right: 0;
	}
}

.properties-header__download-btn,
.properties-header__customer,
.properties-header__history-btn,
.properties-header__edit-btn {
	@include mq($lg) {
		margin-bottom: 10px;
	}
}

.property-details__note-added-icon--delete {
	color: $red;
	cursor: pointer;

	@include hover {
		color: $fiord;
	}
}

.property-details__note-added-icon--edit {
	color: $dodger-blue;
	cursor: pointer;

	@include hover {
		color: $fiord;
	}
}

.properties-header__card--green {
	color: #00AB44;
	border: 1px solid #00AB44;
}

.properties-header__card--blue {
	color: #00bcd4;
	border: 1px solid #00bcd4;
}

.properties-header__card--orange {
	color: #FF8B00;
	border: 1px solid #FF8B00;
}

.properties-header__card {
	padding: 5px 12px 4px 10px;
	display: inline-block;
	border-radius: 8px;
	font-size: 15px;
	margin-right: 10px;
	font-weight: 500;

	@include mq($lg) {
		font-size: 14px;
		margin-right: 10px;
		padding: 5px;

		&:last-of-type {
			margin-right: 0;
		}
	}
}

.properties-header__name {
	font-weight: bold;

	@include mq(640px) {
		font-size: 16px;
	}
}

.properties-header__info-details {
	display: flex;
	flex-direction: column;

	@include mq($xl) {
		margin-bottom: 10px;
	}

	@include mq(640px) {
		flex-wrap: wrap;
	}

	@include mq(450px) {
		flex-direction: column;
		align-items: flex-start;
	}
}

.properties-header__info-details-top {
	display: flex;
	margin-bottom: 9px;
	align-items: center;
}

.properties-header__info-details-bottom {
	margin-left: 35px;
	display: flex;
	align-items: center;
	margin-bottom: 1px;

	@include mq($md) {
		flex-wrap: wrap;
		margin-bottom: 0;
	}

	@include mq(640px) {
		margin-left: 0;
	}
}

.properties-header__price {
	line-height: 1.2;
	font-family: $font-main;
	color: $fiord;
	font-weight: 500;
	font-size: 20px;
	color: $dodger-blue;
	position: relative;
	padding-right: 20px;
	margin-right: 19px;

	&::after {
		content: '';
		position: absolute;
		width: 1px;
		height: 90%;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		opacity: 0.5;
		background-color: $slate-gray;
	}

	@include mq($xl) {
		font-size: 18px;
		padding-right: 15px;
		margin-right: 15px;
	}

	@include mq($lg) {
		font-size: 16px;

	}

	@include mq(640px) {
		font-size: 15px;
		padding-right: 10px;
		margin-right: 10px;
		margin-top: 10px;
	}

	@include mq(400px) {
		width: 100%;

		&::after {
			display: none;
		}
	}
}

.properties-header__info {
	padding: 0 9px 0 0;

	@include mq(1700px) {
		padding: 0;
	}
}

.properties-header__info-wrap {
	display: flex;
	align-items: center;
	position: relative;
	padding-right: 11px;
	margin-right: 19px;

	&::after {
		content: '';
		position: absolute;
		width: 1px;
		height: 55%;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		opacity: 0.5;
		background-color: $slate-gray;

		@include mq(640px) {
			display: none;
		}
	}

	@include mq($xl) {
		padding-right: 15px;
		margin-right: 15px;
	}

	@include mq(640px) {
		padding-right: 0;
		margin-right: 0;
		width: 100%;
	}
}

.properties-header__info-content {
	display: flex;
	align-items: center;

	@include mq(640px) {
		margin-top: 10px;
	}
}

.properties-header__info-content-name {
	display: flex;
	font-size: 14px;
	font-family: $font-main;
	color: $slate-gray;
	position: relative;
	padding-right: 22px;
	margin-right: 19px;

	&::after {
		content: '';
		position: absolute;
		width: 1px;
		height: 95%;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		opacity: 0.5;
		background-color: $slate-gray;
	}

	&:last-of-type {
		&::after {
			display: none;
		}
	}

	@include mq($xl) {
		padding-right: 15px;
		margin-right: 15px;
	}

	@include mq(640px) {
		font-size: 12px;
		padding-right: 10px;
		margin-right: 10px;
	}
}

.properties-header__info-content-name-icon {
	display: inline-block;
	font-size: 12px;
	margin-right: 8px;
}

.properties-header__info-content-text {
	display: flex;
}

.properties-header__description {
	margin-top: 11px;
	margin-right: 10px;

	@include mq($xl) {
        margin-top: 0;
		margin-bottom: 10px;
    }
}

.properties-header__info-content-txt {
	font-family: $font-main;
	font-size: 14px;
	line-height: 1.2;
	color: $fiord;

	@include mq(1440px) {
		font-size: 13px;
	}
}

.page-single-property__note-popup {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
	z-index: 9999;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba($slate-gray, .5);
}

.page-single-property__note-popup-wrap {
	max-width: 476px;
	padding: 25px;
	width: 100%;
	background-color: $white;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-shadow: 0 2px 4px rgba($black, .25);
	border-radius: 8px;

	@include mq($lg) {
		padding: 40px 30px;
		margin: 0 15px;
	}

	@include mq($sm) {
		padding: 40px 15px;
	}
}

.section-title--page-edit-note {
	color: $fiord;
	margin-bottom: 9px;
	align-self: baseline;
}
</style>
